// @greenlight-spec: 15-database-schema.md
// @greenlight-spec: 17-code-organization.md
// `deploying` is non-terminal: scanners passed on a default-branch commit and the
// deploy stage is in flight (15-database-schema.md §pipeline_runs). Terminal readers
// (supersede guard, getApp "last deploy") key on `passed`, never `deploying`.
export const PIPELINE_RUN_STATUSES = [
    'running',
    'deploying',
    'passed',
    'failed',
    'cancelled',
];
export const CHECK_STATUSES = ['running', 'pass', 'fail', 'skip'];
//# sourceMappingURL=pipeline.js.map